interface UseAuthenticationControlsProps {
  selectedCraneId: number | null;
  selectedOperatorId: number | null;
  isLoggedIn: boolean;
  canManageCranes: boolean;
  showLogoutButton: boolean;
  isTouchMode: boolean;
  onCraneSelectionClick: () => void;
  onLogoutClick: () => void;
  onLoginClick?: () => void;
}

export interface AuthenticationControlsProps {
  selectedCraneId: number | null;
  selectedOperatorId: number | null;
  isLoggedIn: boolean;
  canManageCranes: boolean;
  showLogoutButton: boolean;
  isTouchMode: boolean;
  onCraneSelectionClick: () => void;
  onLogoutClick: () => void;
  onLoginClick?: () => void;
}

export const useAuthenticationControls = (
  props: UseAuthenticationControlsProps,
): AuthenticationControlsProps => {
  return {
    selectedCraneId: props.selectedCraneId,
    selectedOperatorId: props.selectedOperatorId,
    isLoggedIn: props.isLoggedIn,
    canManageCranes: props.canManageCranes,
    showLogoutButton: props.showLogoutButton,
    isTouchMode: props.isTouchMode,
    onCraneSelectionClick: props.onCraneSelectionClick,
    onLogoutClick: props.onLogoutClick,
    onLoginClick: props.onLoginClick,
  };
};
